import styled from 'styled-components';

export const ModalCntent = styled.div`
  width: ${p => (p.width ? p.width : '650px')};
  max-height: ${p => (p.height ? p.height : '650px')};
  height: ${p => (p.height ? p.height : 'auto')};
  position: fixed;
  left: 50%;
  top: 50%;
  padding: ${p => (p.padding ? p.padding : '0')};
  overflow: auto;
  transform: translate(-50%, -50%);
  z-index: 11;
  background-color: ${p => (p.bgColor ? p.bgColor : '#fff')};
  border-radius: 8px;

  &.modalHeight450 {
    max-height: 450px;
  }

  &.modalHeight650 {
    max-height: 650px;
  }

  &.modalWidth400 {
    width: 400px;
  }

  &.modalWidth720 {
    width: 720px;
  }
`;
export const ModalBackdrop = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModalClose = styled.span`
  width: 18px;
  height: 18px;
  background-color: #9b9b9b;
  border-radius: 50%;
  display: inline-flex;
  align-content: center;
  justify-content: center;
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
  :before,
  :after {
    position: absolute;
    left: 8px;
    top: 3px;
    content: ' ';
    height: 12px;
    width: 2px;
    background-color: #fff;
  }
  :before {
    transform: rotate(45deg);
  }
  :after {
    transform: rotate(-45deg);
  }
`;
